import styled from "styled-components";
const QualityManagementSub = ({ number, title, text }) => {
  return (
    <Div>
      <div>{number}</div>
      <div className="title">{title}</div>
      <div className="text">{text}</div>
    </Div>
  );
};
export default QualityManagementSub;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.75rem;
  padding: 2rem 1.25rem;
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  & > div:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    font-size: 1.35rem;
    font-weight: 800;
    color: white;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.accent}, ${({ theme }) => theme.colors.dark});
    margin-bottom: 0.5rem;
  }
  & > div.title {
    color: ${({ theme }) => theme.colors.dark};
    font-size: 1.15rem;
    font-weight: 800;
  }
  & > div.text {
    line-height: 1.7;
    color: ${({ theme }) => theme.colors.monotone.dark};
  }
`;
